var _circle, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5001,
    r: 27.5,
    fill: "#F5F5F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_351_970)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6875 28.0001C22.6875 27.0092 22.9605 26.0809 23.4348 25.2861V21.9147H20.0634C18.7253 23.6526 18 25.7705 18 28.0001C18 30.2297 18.7253 32.3476 20.0634 34.0854H23.4348V30.714C22.9605 29.9192 22.6875 28.991 22.6875 28.0001Z",
    fill: "#FBBD00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 33.3126L25.6562 35.6564L28 38.0001C30.2296 38.0001 32.3475 37.2748 34.0854 35.9367V32.5689H30.7175C29.9158 33.0449 28.9836 33.3126 28 33.3126Z",
    fill: "#0F9D58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4349 30.7139L20.0635 34.0854C20.3284 34.4294 20.6169 34.7589 20.929 35.0711C22.8178 36.9598 25.329 38 28.0001 38V33.3125C26.0616 33.3125 24.3627 32.2688 23.4349 30.7139Z",
    fill: "#31AA52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 28.0001C38 27.3917 37.9449 26.7822 37.8363 26.1885L37.7483 25.7081H28V30.3956H32.7442C32.2835 31.312 31.5752 32.0597 30.7175 32.5689L34.0853 35.9367C34.4294 35.6718 34.7589 35.3833 35.0711 35.0712C36.9598 33.1824 38 30.6712 38 28.0001Z",
    fill: "#3C79E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7565 24.2435L32.1708 24.6578L35.4854 21.3433L35.0711 20.929C33.1823 19.0403 30.6711 18.0001 28 18.0001L25.6562 20.3438L28 22.6876C29.419 22.6876 30.7531 23.2401 31.7565 24.2435Z",
    fill: "#CF2D48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0001 22.6876V18.0001C25.329 18.0001 22.8178 19.0403 20.929 20.929C20.6169 21.2411 20.3284 21.5706 20.0635 21.9147L23.4349 25.2861C24.3627 23.7313 26.0617 22.6876 28.0001 22.6876Z",
    fill: "#EB4132"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_351_970"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(18 18.0001)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/Google.6624d6d9991dca00dd451e28240ee025.svg";
export { ForwardRef as ReactComponent };